import { PayoutAccount } from "./payout_account";
import { Time } from "./time";
import { BankAccountDetails } from "./bank_account_details";

export class PaymentAccount extends PayoutAccount {
	// Model used for savings 2.0 SEPA accounts

	private is_confirmed: boolean = false;
	private is_deleted: boolean = false;
	private short_id: string = "";
	private street: string = "";
	private city: string = "";
	private zip: string = "";
	private country_id: string = "";
	private created_at: Time = new Time();
	private bank_account_details: BankAccountDetails = new BankAccountDetails();

	public get bankAccountDetails(): BankAccountDetails {
		return this.bank_account_details;
	}

	public getShortId(): string {
		return this.short_id;
	}

	public getCreationTime(): Time {
		return this.created_at;
	}

	public getIsDeleted(): boolean {
		return this.is_deleted;
	}

	public get isConfirmed(): boolean {
		return this.is_confirmed;
	}

	public set isConfirmed(isConfirmed: boolean) {
		this.is_confirmed = isConfirmed;
	}

	public getStreet(): string {
		return this.street;
	}

	public getCity(): string {
		return this.city;
	}

	public getZip(): string {
		return this.zip;
	}

	public getCountryId(): string {
		return this.country_id;
	}
}
